import {
  Accordion,
  Col,
  Label,
  Rating,
  Row,
  Tooltip,
} from "../../../../../CommonComponents";
import "./AssetInformation.scss";
import { formatPrice } from 'utils';
import Moment from 'moment';
import { CONSTANTS } from "client/utils/constants";
import AttachmentLinkContainer from "client/Components/OrderManagement/ApprovalOrder/LeadrOrder/ItemDetail/AttachmentLink/AttachmentLink-Container";

const AssetInformation = (props: any) => {
  const orderDetails = props?.orderDetails;
  const assetOrderByIdItem = props?.assetOrderByIdItem;
  const assetOrderByIdIndex = props?.assetOrderByIdIndex;
  const detailsByIdItem = props?.detailsByIdItem;
  const isValidForPenaltyFee = props?.isValidForPenaltyFee;
  let actionCommentValue: any[] = [];
  let userActionComment: any[] = [];

  const ExpandedItems: any[] = [];

  
      const OdometerValueChange = () => {
        if (assetOrderByIdItem?.odometerPHourMeter != null) {
            return (assetOrderByIdItem?.odometerPHourMeter)
        } else {
          return ("-")
        }
      }

      ExpandedItems.push({
        headerText: (
          <>
            <div className="LeaderOrderHeader asset-orderDetail">
              <div className={`LeadrOrderSubTitle ${detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST ? 'disposition' :''}`}>
                <div>
                  <Label data-attribute="AssetInformation_Default_Label_64">Asset #</Label>
                  <Tooltip content={assetOrderByIdItem?.assetNo || "-"} data-attribute="AssetInformation_Default_Tooltip_61">
                    <div className="content" >{assetOrderByIdItem?.assetNo || '-'}</div>
                  </Tooltip>
                </div>
                {
                   detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST ?
                   <div>
                    <Label data-attribute="AssetInformation_Default_Label_2_2">Unit #</Label>
                    <Tooltip content={assetOrderByIdItem?.equipmentNo || "-"} data-attribute="AssetInformation_Default_Tooltip_2_2">
                      <div className="content" >{assetOrderByIdItem?.equipmentNo || '-'}</div>
                    </Tooltip>
                  </div> : ''
                }              
                <div>
                  <Label data-attribute="AssetInformation_Default_Label_3_2">{assetOrderByIdItem?.assetType == "vehicle" ? "VIN #" : "Serial #"}</Label>
                  <Tooltip content={assetOrderByIdItem?.vinSerialNumber || "-"} data-attribute="AssetInformation_Default_Tooltip_3_2">
                    <div className="content" >{assetOrderByIdItem?.vinSerialNumber || '-'}</div>
                  </Tooltip>
                </div>
                {
                  detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST ?
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_4_2">Description</Label>
                    <Tooltip content={assetOrderByIdItem?.description || "-"} data-attribute="AssetInformation_Default_Tooltip_4_2">
                      <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
                    </Tooltip>
                  </div> : ''
                }
                <div>
                  <Label data-attribute="AssetInformation_Default_Label_5_2">License Plate #</Label>
                  <Tooltip content={assetOrderByIdItem?.licenseNumber || "-"} data-attribute="AssetInformation_Default_Tooltip_5_2">
                    <div className="content" >{assetOrderByIdItem?.licenseNumber || '-'}</div>
                  </Tooltip>
                </div>
                {
                   detailsByIdItem?.orderRequestType == CONSTANTS.REACTIVATION_REQUEST ?
                   <div>
                      <Label data-attribute="AssetInformation_Default_Label_6_2">Current License Plate #</Label>
                      <Tooltip content={assetOrderByIdItem?.currentLicensePlateNo || "-"} data-attribute="AssetInformation_Default_Tooltip_6_2">
                        <div className="content" >{assetOrderByIdItem?.currentLicensePlateNo || '-'}</div>
                      </Tooltip>
                    </div> : ''
                }               
                <div>
                  <Label data-attribute="AssetInformation_Default_Label_7_2">FRS Item ID #</Label>
                  <Tooltip content={assetOrderByIdItem?.frsOrderNumberItemNo || "-"} data-attribute="AssetInformation_Default_Tooltip_7_2">
                    <div className="content" >{assetOrderByIdItem?.frsOrderNumberItemNo || '-'}</div>
                  </Tooltip>
                </div>
                <div className={`status icon pull-right ${assetOrderByIdItem?.itemStatus == CONSTANTS.ITEM_STATUS.TRANSFER_COMPLETE || assetOrderByIdItem?.itemStatus == CONSTANTS.ITEM_STATUS.DISPOSITION_COMPLETE || assetOrderByIdItem?.itemStatus == CONSTANTS.ITEM_STATUS.REACTIVATION_COMPLETE || assetOrderByIdItem?.itemStatus == CONSTANTS.ITEM_STATUS.SUBMITTED_TO_FINANCE ? 'add-width' :''}`}>
                  <Label className='orderdetail-status-icon' data-attribute="AssetInformation_Default_Label_8_2">
                    {" "}
                    {assetOrderByIdItem?.itemStatus ? props?.iconReturn(assetOrderByIdItem?.itemStatus) : props?.iconReturn(props?.orderDetails?.orderStatus)}
                    <span>{assetOrderByIdItem?.itemStatus ? assetOrderByIdItem?.itemStatus : props?.orderDetails?.orderStatus}</span>
                  </Label>
                </div>
              </div>
            </div>
          </>
        ),
        content: (
          <>
            <div className='asset-information'>
              {
                detailsByIdItem?.orderRequestType == CONSTANTS.TRANSFER_REQUEST ?
                  <div className="Transfer-Asset-OrderDetail">
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_9_2">Color</Label>
                      <Tooltip content={assetOrderByIdItem?.color} data-attribute="AssetInformation_Default_Tooltip_8_2">
                        <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_10_2">Year</Label>
                      <Tooltip content={assetOrderByIdItem?.year} data-attribute="AssetInformation_Default_Tooltip_9_2">
                        <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_11_2">Description</Label>
                      <Tooltip content={assetOrderByIdItem?.description} data-attribute="AssetInformation_Default_Tooltip_10_2">
                        <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_12_2">Equipment Status</Label>
                      <Tooltip content={assetOrderByIdItem?.equipmentStatus} data-attribute="AssetInformation_Default_Tooltip_11_2">
                        <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_13_2">Equipment Class</Label>
                      <Tooltip content={assetOrderByIdItem?.equipmentClass} data-attribute="AssetInformation_Default_Tooltip_12_2">
                        <div className="content" >{assetOrderByIdItem?.equipmentClass || '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_14_2">Net Booked Value</Label>
                      <Tooltip content={formatPrice(assetOrderByIdItem?.netBookedValue, 2)} data-attribute="AssetInformation_Default_Tooltip_13_2">
                        <div className="content" >{typeof assetOrderByIdItem?.netBookedValue == "number" ? `$${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_15_2">Monthly Payment</Label>
                      <Tooltip content={assetOrderByIdItem?.monthlyPaymentAmt} data-attribute="AssetInformation_Default_Tooltip_14_2">
                        <div className="content" >{typeof assetOrderByIdItem?.monthlyPaymentAmt == "number" ? `$${parseFloat(`${assetOrderByIdItem?.monthlyPaymentAmt}`).toFixed(2)}` : '-'}</div>
                      </Tooltip>
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_16_2">Months Remaining</Label>
                      <Tooltip content={assetOrderByIdItem?.monthRemaining} data-attribute="AssetInformation_Default_Tooltip_15_2">
                        <div className="content" >{assetOrderByIdItem?.monthRemaining || '-'}</div>
                      </Tooltip>
                    </div>             
                    <div>
                    {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS && <>
                      <Label data-attribute="AssetInformation_Default_Label_17_2">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                      <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_16_2">
                        <div className="content" >{OdometerValueChange()}</div>
                      </Tooltip>
                    </>}
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_18_2">Overall Condition</Label>
                      <Rating className='mb-2' readOnly={true} rating={assetOrderByIdItem?.overallConditionRating}  data-attribute="AssetInformation_Default_Rating_3" />
                    </div>
                    <div className="attachment-block-orderdetails mb-sm-0 mb-3">
                      <AttachmentLinkContainer
                        item={assetOrderByIdItem}
                        index={assetOrderByIdIndex}
                        itemLevel={"Asset"}
                      />
                    </div>
                    <div>
                      <Label data-attribute="AssetInformation_Default_Label_19_2">Overall Condition Comment</Label>
                      <Tooltip content={assetOrderByIdItem?.overallConditionComments} data-attribute="AssetInformation_Default_Tooltip_17_2">
                        <div className="content" >{assetOrderByIdItem?.overallConditionComments || '-'}</div>
                      </Tooltip>
                    </div>
                  </div> : ''
              }
              {
                detailsByIdItem?.orderRequestType == CONSTANTS.DISPOSITION_REQUEST ? <div className="Disposition-Asset-OrderDetail">
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_20_2">Unit #</Label>
                    <Tooltip content={assetOrderByIdItem?.equipmentNo || "-"} data-attribute="AssetInformation_Default_Tooltip_18_2">
                      <div className="content" >{assetOrderByIdItem?.equipmentNo || '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_21_2">Year</Label>
                    <Tooltip content={assetOrderByIdItem?.year || '-'} data-attribute="AssetInformation_Default_Tooltip_19_2">
                      <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_22_2">Color</Label>
                    <Tooltip content={assetOrderByIdItem?.color || '-'} data-attribute="AssetInformation_Default_Tooltip_20_2">
                      <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_23_2">Equipment Status</Label>
                    <Tooltip content={assetOrderByIdItem?.equipmentStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_21_2">
                      <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
                    </Tooltip>
                  </div>               
                  <div>
                  {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS && <>
                    <Label data-attribute="AssetInformation_Default_Label_24_2">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                    <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_22_2">
                      <div className="content" >{OdometerValueChange()}</div>
                    </Tooltip>
                    </>}
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_25_2">Net Booked Value</Label>
                    <Tooltip content={assetOrderByIdItem?.netBookedValue != null ? `$ ${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_23_2">
                      <div className="content" >{assetOrderByIdItem?.netBookedValue != null ? `$ ${formatPrice(assetOrderByIdItem?.netBookedValue, 2)}` : '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_26_2">Equipment Class</Label>
                    <Tooltip content={assetOrderByIdItem?.equipmentClass || '-'} data-attribute="AssetInformation_Default_Tooltip_24_2">
                      <div className="content" >{assetOrderByIdItem?.equipmentClass || '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_27_2">Monthly Payment</Label>
                    <Tooltip content={assetOrderByIdItem?.monthlyPaymentAmt != null ? `$ ${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_25_2">
                      <div className="content" >{assetOrderByIdItem?.monthlyPaymentAmt != null ? `$ ${formatPrice(assetOrderByIdItem?.monthlyPaymentAmt, 2)}` : '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_28_2">Months Remaining</Label>
                    <Tooltip content={assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'} data-attribute="AssetInformation_Default_Tooltip_26_2">
                      <div className="content" >{assetOrderByIdItem?.monthRemaining != null ? assetOrderByIdItem?.monthRemaining : '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_29_2">Replacement Fleet Asset Order #</Label>
                    <Tooltip content={assetOrderByIdItem?.replacementFleetAssetOrderNo || 'N/A'} data-attribute="AssetInformation_Default_Tooltip_27_2">
                      <div className="content" >{assetOrderByIdItem?.replacementFleetAssetOrderNo || 'N/A'}</div>
                    </Tooltip>
                  </div>   
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_30_2">Replacement Fleet Asset #</Label>
                    <Tooltip content={assetOrderByIdItem?.replacementFleetAssetNo || 'N/A'} data-attribute="AssetInformation_Default_Tooltip_28_2">
                      <div className="content" >{assetOrderByIdItem?.replacementFleetAssetNo || 'N/A'}</div>
                    </Tooltip>
                  </div>                 
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_31_2">Overall Condition</Label>
                    <Rating rating={assetOrderByIdItem?.overallConditionRating} className='overall-rating mb-2' readOnly={true}  data-attribute="AssetInformation_Default_Rating_2_2" />
                  </div>
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_32_2">Estimated Disposition Price</Label>
                    <Tooltip content={assetOrderByIdItem?.estimatedDispoValue != null ? `$ ${formatPrice(assetOrderByIdItem?.estimatedDispoValue, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_29_2">
                      <div className="content" >{assetOrderByIdItem?.estimatedDispoValue != null ? `$ ${formatPrice(assetOrderByIdItem?.estimatedDispoValue, 2)}` : '-'}</div>
                    </Tooltip>
                  </div>
                  <div className='mb-sm-0 mb-3 ps-lg-2 ps-0'>
                    <AttachmentLinkContainer
                      item={assetOrderByIdItem}
                      index={assetOrderByIdIndex}
                      itemLevel={"Asset"}
                    />
                  </div>
                  {assetOrderByIdItem?.showAssetStatus ? 
                  <div>
                     <Label data-attribute="AssetInformation_Default_Label_33_2">Asset Status</Label>
                     <Tooltip content={assetOrderByIdItem?.assetStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_30_2">
                       <div className="content overall-content" >{assetOrderByIdItem?.assetStatus || '-'}</div>
                     </Tooltip>
                  </div>
                  : null}
                  <div>
                    <Label data-attribute="AssetInformation_Default_Label_34_2">Overall Condition Comment</Label>
                    <Tooltip content={assetOrderByIdItem?.overallConditionComments || '-'} data-attribute="AssetInformation_Default_Tooltip_31_2">
                      <div className="content overall-content" >{assetOrderByIdItem?.overallConditionComments || '-'}</div>
                    </Tooltip>
                  </div>
                  <div>
                    {(isValidForPenaltyFee(detailsByIdItem?.dispositionType) && assetOrderByIdItem?.dispositionPenaltyFee > 0 ) ? 
                    <>
                    <Label data-attribute="AssetInformation_Default_Label_35_2">Write off Penalty Fee</Label>
                    <Tooltip content={assetOrderByIdItem?.dispositionPenaltyFee ? `$${formatPrice(assetOrderByIdItem?.dispositionPenaltyFee, 2)}` : '$0.00'} data-attribute="AssetInformation_Default_Tooltip_32_2">
                      <div className="content" >{assetOrderByIdItem?.dispositionPenaltyFee ? `$${formatPrice(assetOrderByIdItem?.dispositionPenaltyFee, 2)}` : '$0.00'}</div>
                    </Tooltip>
                    </>
                    : null} 
                  </div>
                </div> : ''
                }
                {
                    detailsByIdItem?.orderRequestType == CONSTANTS.REACTIVATION_REQUEST ? <div className="Reactivation-Asset-OrderDetail">
                        <div>
                          <Label data-attribute="AssetInformation_Default_Label_36_2">Unit #</Label>
                          <Tooltip content={assetOrderByIdItem?.equipmentNo || "-"} data-attribute="AssetInformation_Default_Tooltip_33_2">
                            <div className="content" >{assetOrderByIdItem?.equipmentNo || '-'}</div>
                          </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_37_2">Color</Label>
                            <Tooltip content={assetOrderByIdItem?.color || '-'} data-attribute="AssetInformation_Default_Tooltip_34_2">
                                <div className="content" >{assetOrderByIdItem?.color || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_38_2">Year</Label>
                            <Tooltip content={assetOrderByIdItem?.year || '-'} data-attribute="AssetInformation_Default_Tooltip_35_2">
                                <div className="content" >{assetOrderByIdItem?.year || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_39_2">Make</Label>
                            <Tooltip content={assetOrderByIdItem?.make || '-'} data-attribute="AssetInformation_Default_Tooltip_36_2">
                                <div className="content" >{assetOrderByIdItem?.make || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_40_2">Model</Label>
                            <Tooltip content={assetOrderByIdItem?.model || '-'} data-attribute="AssetInformation_Default_Tooltip_37_2">
                                <div className="content" >{assetOrderByIdItem?.model || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_41_2">Description</Label>
                            <Tooltip content={assetOrderByIdItem?.description || '-'} data-attribute="AssetInformation_Default_Tooltip_38_2">
                                <div className="content" >{assetOrderByIdItem?.description || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_42_2">Equipment Status</Label>
                            <Tooltip content={assetOrderByIdItem?.equipmentStatus || '-'} data-attribute="AssetInformation_Default_Tooltip_39_2">
                                <div className="content" >{assetOrderByIdItem?.equipmentStatus || '-'}</div>
                            </Tooltip>
                        </div>
                        {assetOrderByIdItem?.assetType !== CONSTANTS.TRAILERS &&
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_43_2">{assetOrderByIdItem?.assetType == "vehicle" ? "Mileage" : assetOrderByIdItem?.assetType == "mower" ? "Hour Meter" : "Odometer / Meter"}</Label>
                            <Tooltip content={OdometerValueChange()} data-attribute="AssetInformation_Default_Tooltip_40_2">
                                <div className="content" >{OdometerValueChange()}</div>
                            </Tooltip>                        
                        </div>
                        }
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_44_2">Disp Cost Center</Label>
                            <Tooltip content={assetOrderByIdItem?.disposeCostCenter || '-' } data-attribute="AssetInformation_Default_Tooltip_41_2">
                                <div className="content" >{assetOrderByIdItem?.disposeCostCenter || '-'}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_45_2">Dispose Date</Label>
                            <Tooltip content={assetOrderByIdItem?.disposalDate != null ? Moment(assetOrderByIdItem?.disposalDate).format("MM/DD/YYYY") : "-"} data-attribute="AssetInformation_Default_Tooltip_42_2">
                                <div className="content" >{ assetOrderByIdItem?.disposalDate != null ? Moment(assetOrderByIdItem?.disposalDate).format("MM/DD/YYYY") : "-"}</div>
                            </Tooltip>
                        </div>
                        <div>
                            <Label data-attribute="AssetInformation_Default_Label_46_2">Gain / Loss</Label>
                            <Tooltip content={assetOrderByIdItem?.gainLoss != null ? assetOrderByIdItem?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetOrderByIdItem?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetOrderByIdItem?.gainLoss, 2)}` : '-'} data-attribute="AssetInformation_Default_Tooltip_43_2">
                                <div className="content" >{assetOrderByIdItem?.gainLoss != null ? assetOrderByIdItem?.gainLoss?.toString().includes('-') ? '$ (' + (formatPrice(assetOrderByIdItem?.gainLoss, 2)) + ')' : `$ ${formatPrice(assetOrderByIdItem?.gainLoss, 2)}` : '-'}</div>
                            </Tooltip>
                        </div>
                        <div className='mb-sm-0 mb-3'>
                            <AttachmentLinkContainer
                                item={assetOrderByIdItem}
                                index={assetOrderByIdIndex}
                                itemLevel={"Asset"}
                            />
                        </div>
                        <div className={assetOrderByIdItem?.assetType == CONSTANTS.TRAILERS ? 'removed-field' : ''}>
                            <Label data-attribute="AssetInformation_Default_Label_47_2">Comments</Label>
                            <Tooltip content={assetOrderByIdItem?.comments != null ? assetOrderByIdItem?.comments : '-'} data-attribute="AssetInformation_Default_Tooltip_44_2">
                                <div className="content" >{assetOrderByIdItem?.comments != null ? assetOrderByIdItem?.comments : '-'}</div>
                            </Tooltip>
                        </div>
                    </div> : ''
                }
            </div>

            <div className="clearfix"></div>
            <Row className="approver-comments">
              <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-sm-2 mb-3'>
                <Label className="approverLbl" data-attribute="AssetInformation_Default_Label_48_2">Approver Comments</Label>
                {!actionCommentValue?.length &&
              props?.orderDetails?.approvalHistory?.map(
                (approvalHistoryItem: any, _index: any) => {
                  const attemptNo = approvalHistoryItem?.attemptNo;
                  const approvalList = approvalHistoryItem?.approvalList;
                  let overrideInserted = false;
                  const filteredList =  approvalList.filter((item :any)=> {
                    if (!(props?.orderDetails?.isApprovalOverride) && item?.approvalHistoryComments?.length) return true;
                    if (props?.orderDetails?.isApprovalOverride) {
                      if(!overrideInserted && item.isApprovalOverride && item?.approvalHistoryComments?.length){
                        overrideInserted = true;
                        return true;
                      }
                      if(!item.isApprovalOverride && item?.approvalHistoryComments?.length){
                        return true;
                      }
                      return false;
                    }
                  });
                  actionCommentValue.push({
                    attemptNo: attemptNo,
                    list: filteredList,
                  });
                }
              )}
            {actionCommentValue?.map((reqVal: any) => {
              return (
                <div key={reqVal?.attemptNo}>
                  {actionCommentValue?.length > 1 && <Label className="blueLabel" data-attribute="AssetInformation_Default_Label_49_2">Attempt {reqVal?.attemptNo}</Label>}
                  { reqVal?.list?.length ?
                    reqVal?.list?.map((step: any) => {
                    if(step?.approvalHistoryComments?.length){
                    return step?.approvalHistoryComments?.map(
                      (valueItem: any, index: any) => {
                        if (valueItem?.comments?.length){
                          userActionComment.push(valueItem);
                          return (
                            <div className="mb-2" key={index}>
                              <span className="Approver-date">
                                {Moment(valueItem?.approvedDate).format(
                                  "MM/DD/YYYY"
                                )}
                              </span>
                              <span className="Approver-name">
                                <b>{valueItem?.approverName}</b>
                              </span>
                              <p className="Approver-comment mt-1">
                                {valueItem?.comments}
                              </p>
                            </div>
                          );
                        }
                      }
                    );
                  }
                  }): actionCommentValue?.length > 1 && <div>-</div>
                  }
                </div>
              );
            })}
            {userActionComment?.length == 0 && actionCommentValue?.length == 1 ? <div>-</div> : null}
              </Col>
              <Col xs={12} sm={12} md={6} lg={6} xl={6} className='mb-sm-2 mb-3'>
                {(orderDetails?.orderStatus == CONSTANTS.ORDER_STATUS.CANCELLED || orderDetails?.orderStatus == CONSTANTS.ORDER_STATUS.REJECTED || orderDetails?.orderStatus == CONSTANTS.ORDER_STATUS.DELETED) ?
                  <>
                    <Label className="approverLbl" data-attribute="AssetInformation_Default_Label_50_2">Cancelled Comments</Label>
                    {orderDetails?.cancelComments ?
                      <div className="mb-2" >
                        <span className="Approver-date">{Moment(orderDetails?.updatedDate).format('MM/DD/YYYY')}</span>
                        <span className="Approver-name"><b>{orderDetails?.modifiedBy}</b></span>
                        <p className="Approver-comment mt-1">
                          {orderDetails?.cancelComments ?? "-"}
                        </p>
                      </div>
                      : '-'}
                  </> : null}
              </Col>
            </Row>
          </>
        ),
        uuid: `Accordion${assetOrderByIdIndex}`,
      });



  return (
    <div className='mt-3'>
      <Accordion
          Items={ExpandedItems}
          preExpanded={["Accordion0"]}
          allowZeroExpanded
          onChange={props.onChange}
          className="custom-accordion asset-information-orderDeatils"
         data-attribute="AssetInformation_Default_Accordion" />      
    </div>
  );
};

export default AssetInformation;
